import api from "../../api";

class ProdutoServico {
  index() {
   return api.get('produtoServico');
  }
}

export default new ProdutoServico();
